<!-- 气泡 -->
<template>
    <div v-if="vipInfo">
        <!-- 免费体验会员生效中 -->
        <div
            v-if="vipInfo.vipStatusName === 'freeVip'"
            class="bubble"
        >
            已享体验会员权益
        </div>
        <!-- 能领取免费体验会员 -->
        <div
            v-else-if="vipInfo.canReceiveFreeVip"
            v-visually="{
                serverId: 17096,
                area: 'btn-addforfree',
            }"
            class="bubble can-click"
            @click="clickBubble()"
        >
            {{ unClaimedText }}
        </div>
    </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import {receiveVip} from '@/utils/commonReq';

export default {
    data() {
        return {
            isSubmit: false
        };
    },
    computed: {
        ...mapState({
            vipInfo: state => state.lawStore.vipInfo,
            userInfoNew: state => state.lawStore?.userInfoNew || {}
        })
    },
    props: {
        // 未领取文案
        unClaimedText: {
            type: String,
            default: ''
        },
        expireKeywords: {
            type: String,
            default: ''
        }
    },
    methods: {
        ...mapMutations({
            emitEvent: 'EventBus/emitEvent'
        }),
        clickBubble() {
            // 免费+btn点击
            this.$wywLog.send({
                serverId: 17096,
                area: 'btn-addforfree',
                action: 'click'
            });
            this.receiveVip();
        },
        // 免费体验会员领取
        receiveVip() {
            if (this.isSubmit) {
                return;
            }
            this.isSubmit = true;
            receiveVip({city_level: this.userInfoNew?.lawyer_info?.city_level}).then(res => {
                this.emitEvent({name: 'global_free_vip_event', payload: {
                    dialogType: 'receive-success',
                    expireKeywords: this.expireKeywords
                }});
            }).finally(() => {
                this.isSubmit = false;
            }).catch(() => {});
        }
    }
};
</script>

<style lang='less' scoped>
.bubble {
    height: 22px;
    background-image: linear-gradient(90deg, #ffe99e 1%, #ffdc68 100%);
    border-radius: 11px;
    padding: 0 10px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #a54300;
    line-height: 22px;
    margin: auto 10px;
    position: relative;
    padding-right: 18px;

    &.can-click {
        cursor: pointer;

        &::after {
            content: "";
            position: absolute;
            height: 9px;
            width: 6px;
            top: 50%;
            right: 8px;
            transform: translateY(-50%);
            background: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-clues/right-arrow-y.png) no-repeat right center / cover;
        }
    }
}
</style>
